module.exports = __webpack_public_path__ + "dbd57c048932943ca44137ca0559d449.woff";